const API_BASE_URL = String(
  process.env.REACT_APP_API_URL || ""
).replace(/\/+$/, "");

const ABSOLUTE_URL_REGEX =
  /^(https?:\/\/|data:|blob:)/i;

export function resolveAdminTutorialMediaUrl(
  mediaUrl
) {
  if (!mediaUrl) {
    return null;
  }

  const value =
    String(mediaUrl).trim();

  if (!value) {
    return null;
  }

  if (
    ABSOLUTE_URL_REGEX.test(value)
  ) {
    return value;
  }

  /*
   * Les futurs fichiers envoyés sur
   * le serveur central.
   */
  if (
    value.startsWith("/uploads/")
  ) {
    return `${API_BASE_URL}${value}`;
  }

  if (
    value.startsWith("uploads/")
  ) {
    return `${API_BASE_URL}/${value}`;
  }

  /*
   * Les chemins /img/... sont résolus
   * depuis le front actuel.
   */
  if (value.startsWith("/")) {
    return value;
  }

  return `/${value}`;
}

export function truncateMediaUrl(
  value,
  maxLength = 80
) {
  const text =
    String(value || "");

  if (
    text.length <= maxLength
  ) {
    return text;
  }

  return `${text.slice(
    0,
    maxLength - 1
  )}…`;
}